<template>
  <div>
    <div class="title is-5">{{ $t("customer info") }}</div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("nit") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.nit"
              placeholder="3952107-9"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-id-card"></i>
            </span>
          </p>
        </div>
      </div>
      <div class="column is-three-fifths">
        <div class="field">
          <label class="label">{{ $t("name") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.name"
              placeholder="Luis Robledo"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("email") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.email"
              placeholder="your@email.com"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-envelope"></i>
            </span>
          </p>
        </div>
      </div>
      <div class="column is-three-fifths">
        <div class="field">
          <label class="label">{{ $t("address") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.address"
              placeholder="1 calle 2-3 zona 4"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-map-marker"></i>
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("zip code") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.zip_code"
              placeholder="01005"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-map-marker"></i>
            </span>
          </p>
        </div>
      </div>
      <div class="column is-three-fifths">
        <div class="field">
          <label class="label">{{ $t("dpi or passport number") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.dpi_or_passport_number"
              placeholder="2528360220101"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-id-card"></i>
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("country") }}</label>
          <div class="control">
            <div class="select">
              <select class="ui dropdown" v-model="meta.country">
                <option value="GT">{{ $t("guatemala") }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("department") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.department"
              placeholder="Guatemala"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-globe"></i>
            </span>
          </p>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("municipality") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.municipality"
              placeholder="Guatemala"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-globe"></i>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Customer",
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      this.meta = data;
    },
    clear() {
      this.meta = {
        nit: "",
        name: "",
        email: "",
        address: "",
        zip_code: "",
        dpi_or_passport_number: "",
        country: "GT",
        department: "",
        municipality: "",
      };
    },
  },
};
</script>
